<h1 mat-dialog-title>Score Details</h1>
<div mat-dialog-content>
  <div *ngFor="let item of data | keyvalue: asIsOrder">
    <span>{{item.key}}: </span>
    <span>{{item.value}}</span>
  </div>
</div>
<div mat-dialog-actions>
    <button type="button" mat-button (click)="onCancel()">Close</button>
</div>
